import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/multi-factor-authentication/multi-factor-authentication-constant';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';
import { OauthAEMConfig } from '../../../../models/login';
import { CancelAuthentication } from '../../../../models/multi-factor-authentication';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { LoginRememberMeUtilsService } from '../../../../utils/login';
import { ApiBuilder, AppConfigService, handleError } from '../../../utils';

@Injectable({
  providedIn: 'root'
})
export class CancelAuthenticationService {
  cancelAuthenticationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.cancelAuthentication+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: LoginRememberMeUtilsService
  ) {}

  cancelAuthentication = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<CancelAuthentication> => {
    const getCancelAuthenticationUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const cancelAuthenticationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getCancelAuthenticationUrl
      }
    ];

    return new ApiBuilder<undefined, CancelAuthentication>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(cancelAuthenticationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.cancelAuthenticationHeader)
      .errorHandler(this._errorHandler)
      .library('CANCEL_AUTHENTICATION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
